import React from "react";
import { Modal, Table } from "antd";
import EwaybillTypeNameMap from "@/map/EwaybillTypeNameMap";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { EwaybillAccountSyncResultItem } from "@/services/api/ewaybillAccount";
import { ColumnsType } from "antd/lib/table";

const columns: ColumnsType<EwaybillAccountSyncResultItem> = [
  {
    title: "电子面单账号",
    dataIndex: "platformUsername",
    render: (text, row, index) => {
      return <span>{text + "(" + EwaybillTypeNameMap[row.ewaybillType] + ")"}</span>;
    },
  },
  {
    title: "同步结果",
    dataIndex: "success",
    render: (text, row, index) => {
      if (text) {
        return <span className="text-success">同步成功</span>;
      } else {
        return <span className="text-error">同步失败:{row.errorMessage}</span>;
      }
    },
  },
];

interface SyncResultModalProps extends InjectBaseModalProps {
  dataSource: EwaybillAccountSyncResultItem[];
}

const SyncResultModal: React.FC<SyncResultModalProps> = function (props) {
  const { visible, onCancel, dataSource } = props;

  return (
    <Modal
      title="电子面单同步结果"
      visible={visible}
      onCancel={onCancel}
      closable={false}
      width={600}
      cancelButtonProps={{
        hidden: true,
      }}
      onOk={onCancel}
    >
      <Table
        size="small"
        rowKey="ewaybillAccountId"
        scroll={{ y: 300 }}
        pagination={false}
        columns={columns}
        dataSource={dataSource}
      />
    </Modal>
  );
};

export default React.memo(SyncResultModal);
